import { useCallback, useMemo, useState } from 'react'
import { Scope } from '@utils'
import { UseAddContactsResult } from '../types'
import { Contact, usePendingContactRequests, useSendContactRequest } from '@hooks'

// Hook principal pour gérer le système addContacts
export const useAddContacts = (navigation: any): UseAddContactsResult => {
  const [selectedContact, setSelectedContact] = useState<Contact|null>(null)
  const [isAddContactModalVisible, setIsAddContactModalVisible] = useState(false)
  const [pendingRequestAccountIdsLocal, setPendingRequestAccountIdsLocal] = useState<Set<string>>(new Set())

  const {mutate: sendContactRequest} = useSendContactRequest()
  const { sentByRecipientId } = usePendingContactRequests()

  // Actions
  const handleAddContact = useCallback((contact: Contact) => {
    setSelectedContact(contact)
    setIsAddContactModalVisible(true)
  }, [setSelectedContact, setIsAddContactModalVisible])

  const handleAddPrivate = useCallback(() => {
    if (!selectedContact) return
    
    sendContactRequest({
      recipientId: selectedContact.accountId,
      scope: Scope.PRIVATE,
    }, {
      onSuccess: () => {
        setPendingRequestAccountIdsLocal((prev) => {
          const next = new Set(prev)
          next.add(selectedContact.accountId)
          return next
        })
      },
    })
    
    setIsAddContactModalVisible(false)
    setSelectedContact(null)
  }, [selectedContact, sendContactRequest, setIsAddContactModalVisible, setSelectedContact])

  const handleAddProfessional = useCallback(() => {
    if (!selectedContact) return
    
      sendContactRequest({
      recipientId: selectedContact.accountId,
      scope: Scope.PROFESSIONAL,
    }, {
      onSuccess: () => {
        setPendingRequestAccountIdsLocal((prev) => {
          const next = new Set(prev)
          next.add(selectedContact.accountId)
          return next
        })
      },
    })
    
    setIsAddContactModalVisible(false)
    setSelectedContact(null)
  }, [selectedContact, sendContactRequest, setIsAddContactModalVisible, setSelectedContact])

  const handleFilterPress = useCallback(() => {
    if (navigation) {
      navigation.navigate('Contacts', { screen: 'ListingContactsFilters', params: { isSuggested: true } })
    }
  }, [navigation])

  const pendingRequestAccountIds = useMemo(
    () => new Set([...sentByRecipientId.keys(), ...pendingRequestAccountIdsLocal]),
    [pendingRequestAccountIdsLocal, sentByRecipientId],
  )

  return {
    // Données
    selectedContact,
    pendingRequestAccountIds,
    
    // États
    isAddContactModalVisible,
    isPending: false, // TODO: Intégrer avec les appels API
    
    // Actions
    setIsAddContactModalVisible,
    handleAddContact,
    handleAddPrivate,
    handleAddProfessional,
    handleFilterPress,
  }
} 